import { useEffect, useState } from 'react';

export const useLocalStorage = (key: string, initialValue?: string) => {
	const [value, setValue] = useState<string | undefined>(() => {
		try {
			const item = window.localStorage.getItem(key);
			return item || initialValue;
		} catch (err) {
			console.warn('useLocalStorage get error:', err);
			return initialValue;
		}
	});

	useEffect(() => {
		const handleStorageChange = (event: StorageEvent) => {
			if (event.key === key) {
				setValue(event.newValue || undefined);
			}
		};

		window.addEventListener('storage', handleStorageChange);

		return () => window.removeEventListener('storage', handleStorageChange);
	}, [key]);

	useEffect(() => {
		try {
			window.localStorage.setItem(key, value ?? '');
		} catch (err) {
			console.warn('useLocalStorage set error:', err);
		}
	}, [key, value]);

	const updateValue = (newValue?: string) => {
		setValue(newValue);
		if (newValue) {
			window.localStorage.setItem(key, newValue);
		} else {
			window.localStorage.removeItem(key);
		}
	};

	return [value, updateValue] as const;
};
